import { RouterConfigurations } from "./types";
import Obj from "core/utility/object";

let routerConfigurationList: RouterConfigurations = {}

/**
 * Set router configuration options
 * 
 * @param {RouterConfigurations} configurations 
 * @returns {void}
 */
export function setRouterConfigurations(configurations: RouterConfigurations): void {
    routerConfigurationList = Obj.merge(routerConfigurationList, configurations)
}

/**
 * Set router config option by given key
 * 
 * @param {string} key
 * @param {any} value 
 * @returns {void}
 */
 export function setRouterConfig(key: string, value: any): void {
    return Obj.set(routerConfigurationList, key, value)
}

/**
 * Get all configurations or get option by key
 * 
 * @param {string} key 
 * @param {any} defaultValue 
 * @returns {any}
 */
export function getRouterConfig(key?: keyof RouterConfigurations | string, defaultValue?: any): any {
    if(!arguments || !key) return routerConfigurationList

    return Obj.get(routerConfigurationList, key, defaultValue)
}